import * as moment from 'moment';
import { helpers } from 'vuelidate/lib/validators';

export default (minDateProp, minDateTimeProp, valueDateTimeProp) => (
  value,
  vm
) => {
  if (!helpers.req(value)) {
    return true;
  }

  const minDate = moment(
    `${vm[minDateProp]} ${vm[minDateTimeProp]}`,
    'YYYY-MM-DD HH:mm'
  );
  const valueDate = moment(
    `${value} ${vm[valueDateTimeProp]}`,
    'YYYY-MM-DD HH:mm'
  );

  return minDate.isBefore(valueDate);
};
